import Swiper from "swiper/bundle";

export const logoSlider = () => {
  const slider = new Swiper(".js-logo-slider", {
    spaceBetween: 0,
    width: 690,
    freeMode: true,
  });
};
